import * as React from 'react';
import { useDispatch } from 'react-redux';
import { UnarchiveItemsModal } from 'ui/indexPages/modals/UnarchiveItemsModal';
import { unarchiveCampaignsRequest } from '../actions';
import { Campaign } from '../types';

const { useCallback } = React;

const displayText = {
  itemTypeName: {
    singular: 'campaign',
    plural: 'campaigns',
  },
};

type UnarchiveCampaignProps = {
  /** Campaign object(s) that are being unarchived. */
  campaigns: Campaign[];
  /** Callback function invoked to close the modal */
  closeModal: () => void;
  /** Callback function invoked to refetch data in table, used after archiving campaign */
  refetch: () => void;
  /** Callback function that is invoked after the user confirms the archive modal. Should deselect all campaigns. */
  deselectAll: () => void;
};

export const UnarchiveCampaignModal = ({
  campaigns = [],
  closeModal = () => null,
  refetch = () => null,
  deselectAll = () => null,
}: UnarchiveCampaignProps) => {
  const dispatch = useDispatch();
  const handleConfirmUnarchive = useCallback(() => {
    closeModal();
    deselectAll();
    dispatch(
      unarchiveCampaignsRequest(
        campaigns.map((campaign) => campaign.id),
        refetch,
      ),
    );
  }, [closeModal, deselectAll, dispatch, campaigns, refetch]);

  return (
    <UnarchiveItemsModal
      displayTextForContentItems={displayText}
      content={campaigns}
      onClose={closeModal}
      onConfirm={handleConfirmUnarchive}
      data-test="unarchive-campaign-modal"
    />
  );
};
